import type { IEntity } from '../../entities/entitiesUtils'
import { entitiesUtils } from '../../entities/entitiesUtils-sidecar'
import { l } from '../../lib/imports'
import { mathUtils } from '../../lib/mathUtils-sidecar'
import { common } from '../../main/common-sidecar'

export interface IItemTweener extends IEntity {
  x1: number
  x2: number
  y1: number
  y2: number
  xs: number
  ys: number
  xe: number
  ye: number
  onUpdate: (x: number, y: number) => void
  state: boolean
  time: number
  elapsed: number
  extraDelay: number
}

const objs: IItemTweener[] = []

export function create(
  x1: number,
  y1: number,
  x2: number,
  y2: number,
  onUpdate: (x: number, y: number) => void,
): IItemTweener {
  let id = common.createId()
  let obj: IItemTweener = {
    eType: 'echo',
    id,
    idLoaded: 0,
    isDead: false,
    x1,
    x2,
    y1,
    y2,
    xs: x1,
    ys: y1,
    xe: x1,
    ye: y1,
    state: false,
    extraDelay: 0,
    elapsed: 0,
    time: 1,

    onUpdate,
  }
  objs.push(obj)
  return obj
}

export function setState(
  obj: IItemTweener,
  state: boolean,
  isImmedate: boolean = false,
) {
  obj.xs = obj.xe
  obj.ys = obj.ye
  obj.elapsed = -obj.extraDelay
  obj.state = state
  if (isImmedate) {
    obj.elapsed = obj.time
  }
}

export function setInstant(obj: IItemTweener, state: boolean) {
  setState(obj, state)
  obj.elapsed = obj.time
  update(obj)
}

export function kill(obj: IItemTweener) {
  obj.isDead = true
}

export function killAll() {
  l.forEach(objs, (c) => {
    c.isDead = true
  })
}

export function updateAll() {
  objs.forEach((c) => {
    update(c)
  })
  entitiesUtils.removeDead(objs, (c) => {})
}
function update(obj: IItemTweener) {
  obj.elapsed += common.getUpdateDelta()

  let t = mathUtils.clamp1(obj.elapsed / obj.time)
  let ti = 1.0 - t

  let xt = 0
  let yt = 0
  if (obj.state) {
    xt = obj.x2
    yt = obj.y2
  } else {
    xt = obj.x1
    yt = obj.y1
  }
  obj.xe = t * xt + ti * obj.xs
  obj.ye = t * yt + ti * obj.ys

  obj.onUpdate(obj.xe, obj.ye)
}
